import { Component, Input } from '@angular/core';
import { BreadcrumbService } from '@shared/layout/services/breadcrumb.service';

export interface Breadcrumb {
  link?: string;
  queryParams?: any;
  text: string;
  active?: boolean;
}

@Component({
  selector: 'sume-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styles: [],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[];

  constructor(public breadcrumbService: BreadcrumbService) {}
}
